<template>
  <div id="approved" :class='{ mobile: isMobile() }' class="fade-in">
    <div class="approved-content">
      <StepInfoHeader :showHeaderHelperIcon="false"/>
      <h2>Parabéns, <span>{{ name | capitalize({ first: true }) }}</span></h2>
      <div class="title">
        <h2>Seu pedido foi aprovado</h2>
        <Icon name="c-check-blue" />
      </div>

      <div class="box-product">
        <img v-if="originalImageUrl" :src="originalImageUrl" alt="Produto" title="Produto">
        <div class="box-product-info">
          <h4>{{ limitedProductName }}</h4>
          <p>Quantidade: {{amount}}</p>
        </div>
      </div>

      <p class="info-text">
        Você já pode acessar sua conta no Parcelex para acompanhar
        suas próximas parcelas.
      </p>

      <div class="footer">
        <Button class="footer-btn" @click="goToMeuParcelex">
          <span>Acessar área do cliente</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UtilMixing from '@/mixins/util';

import Icon from '@/components/ui/AppIcon.vue';
import StepInfoHeader from '../components/StepInfoHeader.vue';
import StringMixin from '../../../mixins/string';

export default {
  name: 'onboarding-approved',
  mixins: [UtilMixing, StringMixin],
  components: { StepInfoHeader, Icon },
  computed: {
    ...mapState('onboarding', [
      'name',
      'productAmount',
      'productName',
      'originalImageUrl',
    ]),
    ...mapState('auth', [
      'token',
    ]),
    limitedProductName() {
      if (!this.productAmount) {
        return '';
      }
      if (typeof this.productName !== 'string' || this.productName.length <= 40) {
        return this.productName;
      }
      return `${this.productName.substring(0, 41)}...`;
    },
    amount() {
      if (this.productAmount < 10) return `0${this.productAmount}`;
      return `${this.productAmount}`;
    },
  },
  methods: {
    goToMeuParcelex() {
      this.$router.push(`/portal?authToken=${this.token}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  #approved {
    padding-top: 20px;
    background-color: var(--gray-100);
    box-sizing: inherit;
    position: relative;
    min-height: 100vh;
    max-width: 100%;
    margin: 0 auto;

    .approved-content {
      padding: 0 24px;
      min-width: $sm;
      max-width: 642px;
      min-height: 304px;
      background-color: var(--white);
      border-radius: 4px;
      border: 1px solid var(--gray-300);
      box-sizing: border-box;
      margin: 0 auto;

      h2 {
        color: var(--gray-600);
        margin-top: 24px;

        span {
          @extend .primary;
        }
      }

      .title {
        h2 {
          display: inline;
        }

        img {
          position: absolute;
          width: 20px;
          margin: 7px 0 0 5px;
        }
      }

      .box-product {
        display: flex;
        align-items: center;

        margin: 16px 0;
        padding: 12px;

        border: 1px solid var(--gray-200);
        border-radius: 4px;

        img {
          width: 64px;
          height: 64px;
          margin-right: 16px;
        }

        .box-product-info {
          p {
            @extend .small-regular;
            margin-top: 4px;
          }
        }
      }

      .info-text {
        @extend .lead;
        margin: 16px 0px;
        line-height: 26px;
      }

      .footer {
        margin-bottom: 20px;
        margin-top: 150px;
        text-align: center;

        .footer-btn {
          @extend .primary;

          width: 224px;
          height: 38px;
        }
      }
    }

    &.mobile {
      padding: 0px;
      background-color: var(--white);

      .approved-content {
        margin: 0 auto;
        min-width: 100%;
        border: 0px;

        .footer {
          margin: 0;
          bottom: 0;
          left: 0;
          box-sizing: border-box;
          position: fixed;
          width: 100%;
          height: 88px;
          padding: 20px 24px;

          img {
            padding-bottom: 1.6px;
          }

          span {
            padding-left: 8px;
          }

          .footer-btn {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>
